/**
 * Labstep
 *
 * @module components/ResourceItemExport/Table/CustomLabel
 * @desc Custom label for resource item export table
 */

import { FieldType } from 'labstep-web/constants/form';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { ShowEditToggleComponent } from 'labstep-web/core/Form/ShowEdit';
import type React from 'react';
import { string } from 'yup';
import styles from './styles.module.scss';
import type { IResourceItemExportTableCustomLabelProps } from './types';

export const fieldCustom: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: undefined,
  name: 'value',
  validation: string(),
  placeholder: 'Field name',
};

export const ResourceItemExportTableCustomLabel: React.FC<
  IResourceItemExportTableCustomLabelProps
> = ({ onSubmit, ...props }) => (
  <div className={styles.customLabel}>
    <ShowEditToggleComponent
      hasValue={false}
      children={null}
      canEdit
      toggledComponent={({ toggle }) => (
        <FormReusable
          fields={[fieldCustom]}
          submitButton={false}
          blurToggle={toggle}
          autoFocus
          onSubmit={(values) => {
            if (values.value) {
              onSubmit(values.value);
            }
            toggle();
          }}
        />
      )}
      {...props}
    />
  </div>
);
